import { render, staticRenderFns } from "./StepHistory.vue?vue&type=template&id=0267e1e3&"
import script from "./StepHistory.vue?vue&type=script&lang=js&"
export * from "./StepHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports